import {
  LogoEmpiricusColor,
  LogoEmpiricus,
  IconInstagram,
  IconYoutube,
  IconLinkedin,
  IconFacebook,
  IconX,
} from "../../assets";
import { IClient } from "..";

export const Empiricus: IClient = {
  colors: {
    primary: [
      "#111111", //0
      "#BB0D31", //1
      "#BB0D31", //2
      "#BB0D31", //3
      "#BB0D31", //4
    ],
    primaryOpacity: [
      "#E7E9EC", //0
      "#FFF3F5", //1
      "#FFF3F5", //2
      "#FFF3F5", //3
      "#FFF3F5", //4
    ],
    complementary: [
      "#169C3C", //0
      "#2C1B73", //1
      "#E3183B", //2
      "#8131E6", //3
      "#FB6815", //4
      "#EB49EE", //5
      "#BB0D31", //6
      "#5E71D7", //7
    ],
    complementaryOpacity: [
      "#E8F5EC", //0
      "#EAE8F1", //1
      "#FCE8EB", //2
      "#F2EAFC", //3
      "#FFEEDE", //4
      "#FDEDFD", //5
      "#EAF5FC", //6
      "#EAF0FC", //7
    ],
    basic: [
      "#FFFFFF", //0
      "#F0F0F0", //1
      "#D7D7D7", //2
      "#B2B1B1", //3
      "#6B6B6B", //4
      "#2F2F2F", //5
    ],
    other: [
      "#FAFBFE", //0
      "#B9B9B9", //1
      "#BB0D31", //2
      "#111111", //3
      "#DEDEDE", //4
      "#B3B1B1", //5
    ],
    alerts: [
      "#F43333", //0
      "#FAAB36", //1
      "#23BD32", //2
      "#EB4747", //3
    ],
    alertsOpacity: [
      "#FEEBEB", //0
      "#FEF7EB", //1
      "#E9F8EB", //2
    ],
  },
  image: {
    logo: LogoEmpiricus,
    icon: LogoEmpiricus,
    icon2: LogoEmpiricusColor,
    logo2: LogoEmpiricusColor,
  },
  name: "Empiricus",
  title: "Empiricus",
  favicon: "favicon-empiricus.ico",
   description:
     "Empiricus - Plataforma de análise e investimentos. Acesse estratégias exclusivas e insights de mercado.",
  acceptLanguage: ["pt-BR", "en-US", "es"],
  autoRegister: false,
  hasBrokers: false,
  hasCancelButton: false,
  hasClarity: false,
  hasFinancial: false,
  redirect: "/meu-portfolio/minhas-compras",
  address: {
    neighborhood: "Itaim bibi",
    street: "Av. Brigadeiro Faria Lima",
    number: "3.477",
    complement: "Torre B, 10º Andar",
    city: "São Paulo",
    state: "SP",
    country: "Brasil",
    zipcode: "04538-133",
  },
  email: {
    email: "relacionamento@empiricus.com.br",
    link: "https://wa.me/5511942949778",
  },
  terms: {
    pt_br: "https://www.empiricus.com.br/termos-de-uso/",
    en_us: "https://www.empiricus.com.br/termos-de-uso/",
    es: "https://www.empiricus.com.br/termos-de-uso/",
  },
  privacyPolicy: {
    pt_br: "https://www.empiricus.com.br/politica-de-privacidade/",
    en_us: "https://www.empiricus.com.br/politica-de-privacidade/",
    es: "https://www.empiricus.com.br/politica-de-privacidade/",
  },
  footerLinksTerms: [
    {
      path: {
        pt_br: "https://www.empiricus.com.br/politica-de-privacidade/",
        en_us: "https://www.empiricus.com.br/politica-de-privacidade/",
        es: "https://www.empiricus.com.br/politica-de-privacidade/",
      },
      name: "global.routes_names.privacy_policy",
    },
    {
      path: {
        pt_br: "https://www.empiricus.com.br/termos-de-uso/",
        en_us: "https://www.empiricus.com.br/termos-de-uso/",
        es: "https://www.empiricus.com.br/termos-de-uso/",
      },
      name: "global.routes_names.terms_of_use",
    },
  ],
  footerLinks: [
    {
      path: {
        pt_br: "https://www.empiricus.com.br/faq/",
        en_us: "https://www.empiricus.com.br/faq/",
        es: "https://www.empiricus.com.br/faq/",
      },
      name: "global.routes_names.help",
    },
  ],
  navbarLinksDefault: [
    {
      name: "global.routes_names.my_portfolio",
      path: "/meu-portfolio",
      subLinks: [
        {
          name: "global.routes_names.my_portfolio_purchases",
          path: "/meu-portfolio/minhas-compras",
        },
      ],
    },
  ],
  navbarLinksClient: [
    {
      name: "global.routes_names.my_portfolio",
      path: "/meu-portfolio",
      subLinks: [
        {
          name: "global.routes_names.my_portfolio_purchases",
          path: "/meu-portfolio/minhas-compras",
        },
      ],
    },
    {
      name: "global.routes_names.operations",
      path: "/operacoes",
      subLinks: [
        {
          name: "global.routes_names.operations_performance",
          path: "/operacoes/desempenho",
        },
        {
          name: "global.routes_names.operations_positions",
          path: "/operacoes/posicoes",
        },
        {
          name: "global.routes_names.operations_orders",
          path: "/operacoes/ordens",
        },
      ],
    },
  ],
  navbarLinksAnalyst: [
    {
      name: "global.routes_names.my_portfolio",
      path: "/meu-portfolio",
      subLinks: [
        {
          name: "global.routes_names.my_portfolio_products",
          path: "/meu-portfolio/meus-servicos",
        },
      ],
    },
    {
      name: "global.routes_names.operations",
      path: "/operacoes",
      subLinks: [
        {
          name: "global.routes_names.operations_product_performance",
          path: "/operacoes/performance-produto",
        },
        {
          name: "global.routes_names.operations_positions",
          path: "/operacoes/posicoes",
        },
        {
          name: "global.routes_names.operations_orders",
          path: "/operacoes/ordens",
        },
      ],
    },
  ],
  socialLinks: [
    {
      path: "https://www.instagram.com/empiricus/",
      icon: IconInstagram,
      name: "Instagram",
    },
    {
      path: "https://www.youtube.com/channel/UCu79AeVqrq42vmSIp1OHyfA",
      icon: IconYoutube,
      name: "Youtube",
    },
    {
      path: "https://www.linkedin.com/company/empiricusinvestimentos/",
      icon: IconLinkedin,
      name: "Linkedin",
    },
    {
      path: "https://www.facebook.com/profile.php?id=100064660330336",
      icon: IconFacebook,
      name: "Facebook",
    },
    {
      path: "https://x.com/empiricus",
      icon: IconX,
      name: "X",
    },
  ],
};
